import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en_US from './en-US'
import zh_CN from './zh-CN'
import zh_TW from './zh-TW'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementZhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
Vue.use(VueI18n)

const messages = {
  'en-US': {
    ...en_US,
    ...elementEnLocale
  },
  'zh-CN': {
    ...zh_CN,
    ...elementZhLocale
  },
  'zh-TW': {
    ...zh_TW,
    ...elementZhTWLocale
  },
}

export function getLanguage() {
  let language = 'zh-CN'
  if(sessionStorage.getItem('service-lang')) {
    language = sessionStorage.getItem('service-lang')
  }
  return language
}
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages
})

export default i18n
